import script from "./CompanyRatingsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanyRatingsView.vue?vue&type=script&lang=ts&setup=true"

import "./CompanyRatingsView.vue?vue&type=style&index=0&id=179c269c&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-179c269c"]])

export default __exports__